import { render } from "./InquiryExperiments.vue?vue&type=template&id=229b0754&scoped=true"
import script from "./InquiryExperiments.vue?vue&type=script&lang=js"
export * from "./InquiryExperiments.vue?vue&type=script&lang=js"

import "./InquiryExperiments.vue?vue&type=style&index=0&id=229b0754&scoped=true&lang=css"

import exportComponent from "E:\\c2stem\\c2-stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229b0754"]])

export default __exports__